import {Injectable} from '@angular/core';
import {HttpService} from './http-service';
import {Observable} from 'rxjs/Rx';

import {CONFIG} from "../app/config";
import {TAction, TContatoTipo, TContatoFlag, TProfileTeam} from "../app/enum";
import {Util} from "../app/util";

import {DeviceDetectorService} from 'ngx-device-detector';
import {StorageService} from "./storage-service";
import {DataService} from "./data-service";
import {Facebook, FacebookLoginResponse} from "@ionic-native/facebook";
import {FacebookService, LoginResponse} from "ngx-facebook";

@Injectable()
export class LogadoService {

    private authUsuario: any = null;

    constructor(public http: HttpService, public util: Util, private storageService: StorageService,
                public dataService: DataService, public deviceService: DeviceDetectorService,
                public faceapp: Facebook, public faceweb: FacebookService) {

        //Facebook Init
        if (!this.util.nativeApp()) this.faceweb.init(CONFIG.iface());

    }

    profileJson(action: TAction, json: any): any {

        if (json.Result) return json;

        if (json.Profile) {
            json.Profile.ProfileZito = (json.Profile.ProfileID == CONFIG.data.ellzitoID);
            json.Profile.ProfileZitu = (json.Profile.ProfileID == CONFIG.data.ellzitoID && json.Profile.ProfileTeam == TProfileTeam.mkManager);
        }

        let logado = this.getAuth();

        //SYNC-Started
        let logadorAuth = (action == TAction.acAuth || action == TAction.acCria) && (!logado && json.Sessao);

        //SYNC-Profile
        let profileAuth = (action == TAction.acLoad || action == TAction.acSave) && ( logado && json.Profile && json.Profile.ProfileID == logado.Profile.ProfileID);

        //ProfileAuth
        if (logadorAuth || profileAuth) this.setAuth(json);

        return json;

    }

    started(action: TAction, json: any = null, params: string = ''): Observable<any> {

        let url = 'SYNC-Started?Action=' + TAction[action] + params;

        let dataJSon = 'JSon=' + JSON.stringify(json);

        let observ: Observable<any>;
        if ( json) observ = this.http.post(url, dataJSon);
        if (!json) observ = this.http.get(url, {}, false);

        return observ.map(data => {

            return this.profileJson(action, data);

        });

    }

    setAuth(rootile) {

        if (rootile && rootile.Sessao) {
            this.storageService.set('LOGADO-SESSAO', rootile.Sessao, true).subscribe();
            this.dataService.set('LOGADO-SESSAO', rootile.Sessao);
        }

        //Limpa e Popula para nao perder a referencia do objeto
        if (rootile.Profile && this.authUsuario && this.authUsuario.Profile && this.authUsuario.Profile.ProfileID == rootile.Profile.ProfileID) {
            this.util.clearObj(this.authUsuario, [], rootile);
            return;
        }

        if (rootile.Profile) this.authUsuario = rootile;

        //Hide Support Button Fab
        (window as any).handappMainInstance.supportShow = /*true*/ (rootile.Profile && rootile.Profile.ProfileZito);

    }

    getAuth() {

        return this.authUsuario;

    }

    logout() {

        this.authUsuario = null;
        this.dataService.set('LOGADO-SESSAO', null);
        this.storageService.set('LOGADO-SESSAO', null, true).subscribe();
        this.storageService.set('INFORMA-SHOWBOARD', null, true).subscribe();
        this.storageService.set('PUBLICO-LOVE', null, true).subscribe();
        this.storageService.set('PUBLICO-SEXO', null).subscribe();

        //TABLET - Somente lancamento
        if (this.deviceService.isTablet()) return;

        //APP
        if (this.util.nativeApp()) {
            this.faceapp.getLoginStatus().then(data => {
                if (data && !!data.authResponse) this.faceapp.logout();
            });
        }

        //WWW
        if (!this.util.nativeApp()) {
            this.faceweb.getLoginStatus().then(data => {
                if (data && !!data.authResponse) this.faceweb.logout();
            });
        }

    }

    voucherQtde(qtde) {

        // Update do Logado Qtde
        this.authUsuario.Aboutme.VoucherQtde += qtde;

    }

    inimigoQtds(qtde) {

        this.authUsuario.Aboutme.InimigoQtde += qtde;

    }

    notifyeQtds(qtde: number) {

        this.authUsuario.Aboutme.NotifyeQtde = qtde;

    }

    paybookHide(paybookID, paybooks?) {

        //Remove do Logado Load
        let index = this.authUsuario.Paybooks.findIndex(PB => PB.PaybookID == paybookID);
        if (index >= 0) this.authUsuario.Paybooks.splice(index, 1);

        //Remove do Array que veio
        if (paybooks) {
            let index = paybooks.findIndex(PB => PB.PaybookID == paybookID);
            if (index >= 0) paybooks.splice(index, 1);
        }

    }

    meritumPush(meritum) {

        if (this.authUsuario.Profile.ProfileID != meritum.Profile.ProfileID) return;

        let meritem = this.authUsuario.Meritums.find(mr => (mr.MeritumID == meritum.MeritumID));
        let indexof = this.authUsuario.Meritums.indexOf(meritem);

        let exist = false;
        if (!exist) exist = !!meritum.BlendedArray.filter(bl => bl.ProdutoCards.find(bx => !!bx.Certify))[0];
        if (!exist) exist = !!meritum.BlendedArray.filter(bl => bl.ProdutoSeals.find(bx => !!bx.Certify))[0];

        if (meritem && !exist) {
            this.authUsuario.Meritums.splice(indexof, 1);
            return;
        }

        if (meritem) {
            this.util.populateObj(meritem, meritum, [], true);
            return;
        }

        this.authUsuario.Meritums.unshift(meritum);

    }

    facebook(): Observable<FacebookLoginResponse | LoginResponse | any> {

        return Observable.create(observer => {

            let fbObj: Promise<FacebookLoginResponse | LoginResponse>;

            if (this.util.nativeApp() && typeof this.faceapp.login !== 'undefined') {
                this.faceapp.logout();
                fbObj = this.faceapp.login(CONFIG.data.facebookScope.split(','));
            }
            else if (typeof this.faceweb.login !== 'undefined') {
                this.faceweb.logout();
                fbObj = this.faceweb.login({scope: CONFIG.data.facebookScope});
            }

            fbObj
                .then((response) => {

                    if (response.status == 'connected') {

                        let contato: any = {};
                        contato.ContatoRede = TContatoTipo.coFace;
                        contato.ContatoFlag = TContatoFlag.cfAuth;
                        contato.ContatoCode = response.authResponse.userID;
                        contato.ContatoUser = '';
                        contato.ContatoData = this.util.dateToStr();
                        contato.ContatoLink = '';
                        contato.ContatoHash = response.authResponse.accessToken;
                        contato.ContatoLock = response.authResponse.expiresIn;
                        contato.ContatoFoto = 'https://graph.facebook.com/me/picture?width=1000' +      '&access_token=' + response.authResponse.accessToken;
                        contato.ContatoMini = 'https://graph.facebook.com/me/picture?width=250&height=250&access_token=' + response.authResponse.accessToken;

                        let object = {contato: contato, authResponse: response.authResponse};
                        observer.next(object);
                        observer.complete();

                    }
                    else {

                        let data = {
                            Titulo: 'Erro de Login',
                            Result: ((response.status == 'not_authorized' || !response.status) ? 'Autorize o Lorean no Facebook para continuar.' : response.status)
                        };

                        observer.error(data);
                        observer.complete();

                    }

                })
                .catch((erro: any) => {

                    let data = {
                        Titulo: 'Erro de Login',
                        Result: (!erro ? 'Login com Facebook falhou' : JSON.stringify(erro))
                    };

                    observer.error(data);
                    observer.complete();

                });

        });
    }

}



// WEBPACK FOOTER //
// ./src/providers/logado-service.ts